"use strict";

exports.__esModule = true;
exports.getMainPageHeaderTextAlignment = exports.getCategoryTextAlignment = exports.getMainPageHeaderHeight = exports.getHeaderHeight = exports.getIsHeaderEnabled = exports.getIsMainPageHeaderEnabled = exports.getIsFooterPostsEnabled = exports.getIsBadgesEnabled = exports.getIsListHashtagsEnabled = exports.getIsViewsCountEnabled = exports.getIsLoginWidgetEnabled = exports.getIsShowSubcategoriesEnabled = void 0;

var _wixParams = require("../constants/wix-params");

var _appSettingsSelectors = require("../store/app-settings/app-settings-selectors");

var _memberAreaSelectors = require("./member-area-selectors");

var _textAlignment = require("../constants/text-alignment");

var getIsShowSubcategoriesEnabled = function getIsShowSubcategoriesEnabled(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      getIsMobile = _ref.getIsMobile;

  return function (state, style, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        getMobileSettingsValue = _ref2.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_SHOW_SUBCATEGORIES_ENABLED_PATH,
      fallback: false,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsShowSubcategoriesEnabled = getIsShowSubcategoriesEnabled;

var getIsLoginWidgetEnabled = function getIsLoginWidgetEnabled(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
      getIsMobile = _ref3.getIsMobile;

  return function (state, style, _temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        getMobileSettingsValue = _ref4.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_LOGIN_WIDGET_ENABLED_PATH,
      fallback: !(0, _memberAreaSelectors.isMemberAreaActive)(state),
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsLoginWidgetEnabled = getIsLoginWidgetEnabled;

var getIsViewsCountEnabled = function getIsViewsCountEnabled(_temp5) {
  var _ref5 = _temp5 === void 0 ? {} : _temp5,
      getIsMobile = _ref5.getIsMobile;

  return function (state, style, _temp6) {
    var _ref6 = _temp6 === void 0 ? {} : _temp6,
        getMobileSettingsValue = _ref6.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_VIEWS_COUNT_ENABLED_PATH,
      fallback: true,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsViewsCountEnabled = getIsViewsCountEnabled;

var getIsListHashtagsEnabled = function getIsListHashtagsEnabled(_temp7) {
  var _ref7 = _temp7 === void 0 ? {} : _temp7,
      getIsMobile = _ref7.getIsMobile;

  return function (state, style, _temp8) {
    var _ref8 = _temp8 === void 0 ? {} : _temp8,
        getMobileSettingsValue = _ref8.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_LIST_HASHTAGS_ENABLED_PATH,
      fallback: true,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsListHashtagsEnabled = getIsListHashtagsEnabled;

var getIsBadgesEnabled = function getIsBadgesEnabled(_temp9) {
  var _ref9 = _temp9 === void 0 ? {} : _temp9,
      getIsMobile = _ref9.getIsMobile;

  return function (state, style, _temp10) {
    var _ref10 = _temp10 === void 0 ? {} : _temp10,
        getMobileSettingsValue = _ref10.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_BADGES_ENABLED_PATH,
      fallback: true,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsBadgesEnabled = getIsBadgesEnabled;

var getIsFooterPostsEnabled = function getIsFooterPostsEnabled(_temp11) {
  var _ref11 = _temp11 === void 0 ? {} : _temp11,
      getIsMobile = _ref11.getIsMobile;

  return function (state, style, _temp12) {
    var _ref12 = _temp12 === void 0 ? {} : _temp12,
        getMobileSettingsValue = _ref12.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_FOOTER_POSTS_ENABLED_PATH,
      fallback: true,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsFooterPostsEnabled = getIsFooterPostsEnabled;

var getIsMainPageHeaderEnabled = function getIsMainPageHeaderEnabled(_temp13) {
  var _ref13 = _temp13 === void 0 ? {} : _temp13,
      getIsMobile = _ref13.getIsMobile;

  return function (state, style, _temp14) {
    var _ref14 = _temp14 === void 0 ? {} : _temp14,
        getMobileSettingsValue = _ref14.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_MAIN_PAGE_HEADER_ENABLED_PATH,
      fallback: true,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsMainPageHeaderEnabled = getIsMainPageHeaderEnabled;

var getIsHeaderEnabled = function getIsHeaderEnabled(_temp15) {
  var _ref15 = _temp15 === void 0 ? {} : _temp15,
      getIsMobile = _ref15.getIsMobile;

  return function (state, style, _temp16) {
    var _ref16 = _temp16 === void 0 ? {} : _temp16,
        getMobileSettingsValue = _ref16.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.IS_HEADER_ENABLED_PATH,
      fallback: true,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getIsHeaderEnabled = getIsHeaderEnabled;

var getHeaderHeight = function getHeaderHeight(_temp17) {
  var _ref17 = _temp17 === void 0 ? {} : _temp17,
      getIsMobile = _ref17.getIsMobile;

  return function (state, style, _temp18) {
    var _ref18 = _temp18 === void 0 ? {} : _temp18,
        getMobileSettingsValue = _ref18.getMobileSettingsValue;

    var isMobile = getIsMobile && getIsMobile(state);
    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.HEADER_HEIGHT_PATH,
      fallback: isMobile ? 200 : 250,
      state: state,
      isMobileSettingsValue: isMobile || getMobileSettingsValue,
      useDesktopFallback: false
    });
  };
};

exports.getHeaderHeight = getHeaderHeight;

var getMainPageHeaderHeight = function getMainPageHeaderHeight(_temp19) {
  var _ref19 = _temp19 === void 0 ? {} : _temp19,
      getIsMobile = _ref19.getIsMobile;

  return function (state, style, _temp20) {
    var _ref20 = _temp20 === void 0 ? {} : _temp20,
        getMobileSettingsValue = _ref20.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.MAIN_PAGE_HEADER_HEIGHT_PATH,
      fallback: getHeaderHeight({
        getIsMobile: getIsMobile
      })(state, style),
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue,
      useDesktopFallback: false
    });
  };
};

exports.getMainPageHeaderHeight = getMainPageHeaderHeight;

var getCategoryTextAlignment = function getCategoryTextAlignment(_temp21) {
  var _ref21 = _temp21 === void 0 ? {} : _temp21,
      getIsMobile = _ref21.getIsMobile;

  return function (state, style, _temp22) {
    var _ref22 = _temp22 === void 0 ? {} : _temp22,
        getMobileSettingsValue = _ref22.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.CATEGORY_TEXT_ALIGNMENT_PATH,
      fallback: _textAlignment.TEXT_ALIGNMENT_CENTER,
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getCategoryTextAlignment = getCategoryTextAlignment;

var getMainPageHeaderTextAlignment = function getMainPageHeaderTextAlignment(_temp23) {
  var _ref23 = _temp23 === void 0 ? {} : _temp23,
      getIsMobile = _ref23.getIsMobile;

  return function (state, style, _temp24) {
    var _ref24 = _temp24 === void 0 ? {} : _temp24,
        getMobileSettingsValue = _ref24.getMobileSettingsValue;

    return (0, _appSettingsSelectors.getAppSettingsValue)({
      style: style,
      key: _wixParams.MAIN_PAGE_TEXT_ALIGNMENT_PATH,
      fallback: getCategoryTextAlignment({
        getIsMobile: getIsMobile
      })(state, style),
      state: state,
      isMobileSettingsValue: getIsMobile ? getIsMobile(state) : getMobileSettingsValue
    });
  };
};

exports.getMainPageHeaderTextAlignment = getMainPageHeaderTextAlignment;